<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid search-product">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Search for Products</h4>
            <hr />
            <div>
              <div>
                <label>Filters</label>
              </div>

              <div>
                <form @submit.prevent="searchProducts" class="border p-3">
                  <div class="row">
                    <div class="col-md-12 col-lg-4">
                      <div class="mb-3">
                        <label for="prodName" class="form-label"
                          >Product name:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="prodName"
                          v-model="form.prodName"
                        />
                      </div>

                      <div class="mt-3 mb-3">
                        <label for="supplier" class="form-label"
                          >Supplier:</label
                        >
                        <select
                          class="form-control"
                          aria-label=".form-select-sm example"
                          v-model.number="form.supplierId"
                        >
                          <option value="0">Select Supplier</option>
                          <option
                            v-for="supplier in suppliersResults"
                            :key="supplier.id"
                            :value="supplier.id"
                          >
                            {{ supplier.name }}
                          </option>
                        </select>
                      </div>

                      <div class="mt-4 mb-3">
                        <label
                          class="form-check-label"
                          for="includeDeletedProducts"
                          >Include deleted products:</label
                        >

                        <b-form-checkbox
                          class="mt-1"
                          :true-value="true"
                          :false-value="false"
                          id="includeDeletedProducts"
                          v-model="form.includeDeletedProducts"
                          switch
                        />
                      </div>

                      <div class="mt-4">
                        <label
                          class="form-check-label"
                          for="excludeDynamicVendor"
                          >Include Dynamic Vendor:</label
                        >

                        <b-form-checkbox
                          class="mt-1"
                          :true-value="true"
                          :false-value="false"
                          id="excludeDynamicVendor"
                          v-model="form.excludeDynamicVendor"
                          switch
                        />
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-4">
                      <div class="mb-3">
                        <label for="skuProductNumber" class="form-label"
                          >SKU or Product number:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="skuProductNumber"
                          v-model="form.skuProductNumber"
                        />
                      </div>

                      <div class="mt-3 mb-3">
                        <label for="sku" class="form-label">Category:</label>
                        <select
                          class="form-control"
                          aria-label=".form-select-sm example"
                          @change="getCategoryOne($event)"
                          v-model="form.categoryID"
                        >
                          <option
                            v-for="category in allCategory"
                            :key="category.id"
                            :value="category.hid"
                            :data-id="category.categoryID"
                          >
                            {{ category.label }}  <span v-if="category.notes"> ({{ category.notes }})</span>
                          </option>
                        </select>
                      </div>

                      <div class="mt-3 mb-3">
                        <label for="sku" class="form-label"
                          >Subcategory 1:</label
                        >
                        <select
                          class="form-control"
                          aria-label=".form-select-sm example"
                          @change="getCategoryTwo($event)"
                          v-model="form.subCatID1"
                        >
                          <option
                            v-for="category in allCategoryOne"
                            :key="category.id"
                            :value="category.hid"
                            :data-id="category.categoryID"
                          >
                            {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
                          </option>
                        </select>
                      </div>

                      <div class="mt-3 mb-3">
                        <label for="sku" class="form-label"
                          >Subcategory 2:</label
                        >
                        <select
                          class="form-control"
                          aria-label=".form-select-sm example"
                          v-model="form.subCatID2"
                          @change="leafCategoryChange($event)"
                        >
                          <option
                            v-for="category in allCategoryTwo"
                            :key="category.id"
                            :value="category.hid"
                            :data-id="category.categoryID"
                          >
                            {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 mt-4">
                      <div class="row">
                        <div class="col-md-3">
                          <input
                            type="submit"
                            value="Search Products"
                            class="btn btn-primary"
                          />
                        </div>
                        <div class="col-md-3">
                          <button type="button" class="btn btn-warning" :disabled="isDisabled" @click="exportProducts()">Export Products <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>
                          <br><a href="javascript:void(0)" @click="downloadProductImportBlankTemplate()"><i class="fas fa-download"></i> Download  Blank Template</a>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="col-md-12 mt-4">
                      <div class="row">
                        <div class="col-md-12">
                          <form>
                            <div class="form-row align-items-center">
                              <div class="col-md-5">
                                <input class="form-control" type="file" id="formFile" @change="handleFileUpload( $event )">
                              </div>
                              <div class="col-md-2">
                                <button type="button" class="btn btn-dark" :disabled="isDisabled" @click="importProduct()">Import Products <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>
                              </div>
                              <div class="col-md-5">
                                  <ul>
                                    <li><b>For Deleting Product: </b> Deleted = 1, Supplier SKU Status = 1 & Available = 0</li>
                                    <li><b>For Deleting Denomination: </b> Deleted = 0, Supplier SKU Status = 1 & Available = 0</li>
                                    <li><b>Deleted & Supplier SKU Status:</b> 0 Means Not Deleted, 1 Means Deleted</li>
                                    <li><b>Available:</b> 1 Means Available, 0 Means Not Available</li>
                                  </ul>
                              </div>
                            </div>
                          </form>
                          <div class="pt-2" v-if="importProductResponse">
                            <h4>Import Summary</h4>
                            <p><b>Total Rows:</b> {{ importProductResponse.csv_records_found }}</p>
                            <p><b>Rows Proceed:</b> {{ importProductResponse.csv_records_found - importProductResponse.error_count }}</p>
                            <p><b>Rows Not Proceed:</b> {{ importProductResponse.error_count }}</p>
                            <p v-if="importProductResponse.error_logs_file"><b>Detail Error Logs File:</b> <a :href="importProductResponse.error_logs_file" >Error File</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="row mt-3">
                <div class="ml-2">
                  <router-link to="/add-product">
                    <button class="btn btn-primary">Add Product</button>
                  </router-link>
                </div>
              </div>
            </div>
            <hr />
            <div v-if="isLoading === true">
              <div class="centered-spinner">
                <a-spin />
              </div>
            </div>

            <div id="product-list" v-if="showSearch === true">
              <div class="row">
                <div class="col-md-12">
                  <p v-if="allProducts.totalRecords === null">
                    No products found
                  </p>
                  <p class="align-middle border p-2 bg rounded-1" v-else>
                    {{ allProducts.totalRecords }} products found
                  </p>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-3">
                <div class="d-flex">
                  <div>
                    <label class="mt-1">Show </label>
                  </div>
                  <div>
                    <select
                      class="form-control ml-1"
                      v-model.number="perPage"
                      @change="getProducts"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div class="ml-2">
                    <label class="mt-1">entries</label>
                  </div>
                </div>
              </div>
              <div :class="[loading ? 'table-active' : '']">
                <div class="table-responsive mt-2">
                  <table class="table table-bordered border-light">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style="cursor: pointer;"
                          @click="setSortFieldAndOrder('name')"
                        >
                          Name
                          <span
                            >&nbsp;<i class="fa-solid fa-sort sort-color"></i
                          ></span>
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer;"
                          @click="setSortFieldAndOrder('productid')"
                        >
                          Id
                          <span
                            >&nbsp;<i class="fa-solid fa-sort sort-color"></i
                          ></span>
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer; min-width: 120px;"
                          @click="setSortFieldAndOrder('price')"
                        >
                          Wholesale
                          <span
                            >&nbsp;<i class="fa-solid fa-sort sort-color"></i
                          ></span>
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer; min-width: 100px;"
                          @click="setSortFieldAndOrder('deleted')"
                        >
                          Deleted
                          <span
                            >&nbsp;<i class="fa-solid fa-sort sort-color"></i
                          ></span>
                        </th>
                        <th
                          scope="col"
                          style="cursor: pointer;"
                          @click="setSortFieldAndOrder('sku')"
                        >
                          SKU
                          <span
                            >&nbsp;<i class="fa-solid fa-sort sort-color"></i
                          ></span>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-if="allProducts.Result === null">
                        <div class="white-space">
                          No data available in table
                        </div>
                      </tr>
                      <tr v-if="loading === true">
                        <div>
                          <div class="centered">
                            <a-spin />
                          </div>
                        </div>
                      </tr>
                      <tr
                        v-for="product in allProducts.Result"
                        :key="product.id"
                      >
                        <td>
                          <router-link
                            :to="{
                              name: 'EditProduct',
                              params: {
                                Id: product.productsParent.productid,
                              },
                            }"
                            ><span>{{
                              product.productsParent.name
                            }}</span></router-link
                          >
                        </td>
                        <td>
                          <span>{{ product.productsParent.productid }}</span>
                        </td>
                        <td class="text-left">
                          <span>{{
                            product.productsChildren[0].price
                              ? "$" +
                                product.productsChildren[0].price.toLocaleString()
                              : "-"
                          }}</span>
                        </td>
                        <td class="text-center">
                          <span>{{
                            product.productsParent.deleted ? "Yes" : "No"
                          }}</span>
                        </td>
                        <td>
                          <span>{{
                            product.productsChildren[0].distributersku
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-between">
                    <div>
                      <span v-if="allProducts.Result === null"
                        >Showing 0 to 0 of 0 entries</span
                      >
                      <span v-else
                        >Showing
                        {{ (currentPage - 1) * allProducts.pageSize + 1 }} to
                        {{
                          (currentPage - 1) * allProducts.pageSize +
                            allProducts.selectedRecordCount
                        }}
                        of {{ allProducts.totalRecords }} entries</span
                      >
                    </div>
                    <div class="" v-if="allProducts.Result">
                      <pagination
                        :data="allProducts.Result"
                        :totalPages="
                          Math.ceil(allProducts.totalRecords / perPage)
                        "
                        :total="allProducts.totalRecords"
                        :perPage="perPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import Pagination from "@/components/Pagination.vue";
import DashboardService from "../../../../services/DashboardService"
export default {
  name: "ManageProducts",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      form: {
        pageNumber: 1,
        pageSize: 10,
        sortField: "",
        sortOrder: "",
        prodName: "",
        supplierId: null,
        includeDeletedProducts: false,
        excludeDynamicVendor: false,
        skuProductNumber: "",
        categoryID: "",
        subCatID1: "",
        subCatID2: "",
      },
      currentPage: 1,
      perPage: 10,
      loading: false,
      isLoading: false,
      showSearch: false,
      isDisabled: false,
      filterCategoryId1: null,
      filterCategoryId2: null,
      filterCategoryId3: null,
      csvFile: "",
      importProductResponse: null
    };
  },

  methods: {
    searchProducts() {
      this.currentPage = 1;
      this.isLoading = true;
      this.$store
        .dispatch("manageProducts/fetchAllProducts", this.form)
        .then(() => {
          this.isLoading = false;
          this.showSearch = true;
        })
        .then(() => {
          const el = document.getElementById("product-list");
          el.scrollIntoView({ behavior: "smooth" });
        });
    },
    async exportProducts() {
        this.isDisabled =true;
        if (this.filterCategoryId1) {
          this.form.filterCategoryId = this.filterCategoryId1
        }
        if (this.filterCategoryId2) {
          this.form.filterCategoryId = this.filterCategoryId2
        }
        if (this.filterCategoryId3) {
          this.form.filterCategoryId = this.filterCategoryId3
        }
        await DashboardService.exportProducts(this.form)
          .then((response) => {
            this.isDisabled =false;
            if (response.status == 200) {
              window.location.href = response.data.data;
            } else {
              alert("Issue in exporting products")
            }
          }).catch((e) => {
            this.isDisabled =false;
            alert(e.response.data.respones_msg);
          });
    },
    async downloadProductImportBlankTemplate() {
      await DashboardService.downloadProductImportBlankTemplate()
        .then((response) => {
          if (response.status == 200) {
            window.location.href = response.data.data;
          } else {
            alert("Issue in exporting products")
          }
        }).catch((e) => {
          this.isDisabled =false;
          alert(e.response.data.respones_msg);
        });
    },
    handleFileUpload(event){
      this.csvFile = event.target.files[0];
    },
    async importProduct() {
      this.importProductResponse = null;
      if (this.csvFile.type != "text/csv") {
          alert("Please select csv file for import");
          return false;
      }
      this.isDisabled =true;
      let formData = new FormData();
      formData.append("csv_file", this.csvFile);
      DashboardService.importProduct(formData)
        .then((response) => {
            this.isDisabled =false;
            if (response.status == 200) {
              this.importProductResponse = response.data
            }
            console.log(this.importProductResponse)
            alert(response.data.responseMessage);
        }).catch((e) => {
          this.isDisabled =false;
          console.log({e});
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.$store
        .dispatch("manageProducts/fetchAllProducts", {
          ...this.form,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        })
        .then(() => {
          this.loading = false;
        });
    },
    getProducts() {
      console.log(this.perPage);
      this.currentPage = 1;
      this.loading = true;
      this.$store
        .dispatch("manageProducts/fetchAllProducts", {
          ...this.form,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        })
        .then(() => {
          this.loading = false;
        });
    },
    setSortFieldAndOrder(fieldName) {
      if (this.form.sortOrder === "") {
        this.form.sortOrder = "ASC";
      } else {
        this.form.sortOrder = this.form.sortOrder === "ASC" ? "DESC" : "ASC";
      }

      this.form.sortField = fieldName;
      this.loading = true;
      this.$store
        .dispatch("manageProducts/fetchAllProducts", {
          ...this.form,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        })
        .then(() => {
          this.loading = false;
        });
    },
    getCategoryOne(e) {
      console.log(e.target.value);
      this.filterCategoryId1 = e.target.options[e.target.options.selectedIndex].getAttribute('data-id');
      this.$store.commit("divvyCategory/SET_CATEGORIES_ONE", []);
      this.$store.commit("divvyCategory/SET_CATEGORIES_TWO", []);
      this.form.subCatID1 = "";
      this.form.subCatID2 = "";
      this.$store.dispatch("divvyCategory/fetchSubCategoriesOne", {
        categoryID: e.target.value,
      });
    },
    getCategoryTwo(e) {
      this.filterCategoryId2 = e.target.options[e.target.options.selectedIndex].getAttribute('data-id');
      this.$store.commit("divvyCategory/SET_CATEGORIES_TWO", []);
      this.form.subCatID2 = "";
      console.log(e.target.value);
      this.$store.dispatch("divvyCategory/fetchSubCategoriesTwo", {
        categoryID: e.target.value,
      });
    },
    leafCategoryChange(e) {
      this.filterCategoryId3 = e.target.options[e.target.options.selectedIndex].getAttribute('data-id');
    },
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageProducts",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },
  computed: {
    allSuppliers() {
      return this.$store.getters["manageSuppliers/allSuppliers"];
    },
    suppliersResults() {
      return this.$store.getters["manageSuppliers/suppliersResults"];
    },
    allCategory() {
      return this.$store.getters["divvyCategory/allCategories"];
    },
    allCategoryOne() {
      return this.$store.getters["divvyCategory/allCategoriesOne"];
    },
    allCategoryTwo() {
      return this.$store.getters["divvyCategory/allCategoriesTwo"];
    },
    allProducts() {
      return this.$store.getters["manageProducts/allProducts"];
    },
  },
  mounted() {
    this.$store.dispatch("divvyCategory/fetchCategories", {
      categoryID: "/",
    });
    this.$store.dispatch("manageSuppliers/fetchAllSuppliers", {
      searchTerm: "",
      pageNumber: 1,
      pageSize: 500,
      sortField: "[NAME]",
      sortOrder: "ASC",
    });
    if (this.allProducts.Result) {
      this.showSearch = true;
    } else {
      this.showSearch = false;
    }
  },

  created() {
    this.setActiveMenuItem();
  },

  destroyed() {
    this.$store.state.manageProducts.products = {};
    this.$store.commit("divvyCategory/SET_CATEGORIES_ONE", []);
    this.$store.commit("divvyCategory/SET_CATEGORIES_TWO", []);
  },
};
</script>
<style lang="scss" scoped>
.search-product {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.success {
  background-color: #dff0d8;
  height: 60px;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

.table-active {
  opacity: 0.4;
}

.bg {
  color: #468846;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
</style>
